import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center h-100 otp-panel" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "col-9 h-100 d-flex flex-column py-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-center mb-5 mt-4" }, "Verify phone")
  ])
], -1)
const _hoisted_6 = { class: "text-center mb-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/mobile-icon.png",
  class: "mb-5",
  width: "70"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h6", { class: "text-primary text-uppercase fw-bold" }, "Enter the 6-digit OTP code", -1)
const _hoisted_9 = { class: "text-muted fw-bold" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h6", { class: "text-success text-uppercase fw-bold" }, "Success", -1)
const _hoisted_11 = { class: "text-muted fw-bold" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h6", { class: "text-danger text-uppercase fw-bold" }, "Incorrect code", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted fw-bold" }, "Try Entering the OTP Code again", -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "otp-container" }
const _hoisted_16 = { class: "d-flex flex-row justify-content-center" }
const _hoisted_17 = { class: "text-center mt-auto" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h6", { class: "text-center fw-bold text-muted" }, "Didn't receive SMS?", -1)
const _hoisted_19 = { class: "text-center fw-bold text-muted" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" or ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_otp_input = _resolveComponent("v-otp-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: "#",
      class: "text-primary w-25 start-0 position-absolute mt-3 ms-3",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closePanel()))
    }, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.onSuccess || _ctx.onError ? 'd-none' : '')
        }, [
          _hoisted_8,
          _createElementVNode("p", _hoisted_9, "We’ve sent it to " + _toDisplayString(_ctx.phone), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.onSuccess ? '' : 'd-none')
        }, [
          _hoisted_10,
          _createElementVNode("p", _hoisted_11, "We’ve sent it to " + _toDisplayString(_ctx.phone), 1)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.onError ? '' : 'd-none')
        }, _hoisted_14, 2)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_v_otp_input, {
            ref: "otpInput",
            "input-classes": "otp-input small fw-bold",
            separator: " ",
            "num-inputs": 6,
            "should-auto-focus": true,
            "is-input-num": true,
            conditionalClass: ['one', 'two', 'three', 'four', 'five', 'six'],
            placeholder: ['', '', '', ''],
            onOnChange: _ctx.handleOnChange,
            onOnComplete: _ctx.handleOnComplete
          }, null, 8, ["onOnChange", "onOnComplete"])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("h6", _hoisted_19, [
          _createElementVNode("a", {
            href: "#",
            class: "fw-bold text-primary",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.resendOTP()), ["prevent"]))
          }, "Resent"),
          _hoisted_20,
          _createElementVNode("a", {
            href: "#",
            class: "fw-bold text-primary",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.closePanel()), ["prevent"]))
          }, "Change Phone Number")
        ])
      ])
    ])
  ]))
}